// extracted by mini-css-extract-plugin
module.exports = {"modal":"OfferDocumentsInfoPopup_modal__45j_D","header":"OfferDocumentsInfoPopup_header__WzGu8"};